storefrontApp.service('embrillianceElasticService', function () {
    this.buildStarterPacksRequest = function (size, definitionNames) {
        size = size || 6;
        var mustArray = [
            '{"term":{"categoriesList.keyword":"embrilliance starter packs"}}',
            '{"term":{"inStock":true}}',
            '{"range":{"listPrice":{"gt":0}}}'
        ];
        if (definitionNames && definitionNames.length > 0) {
            var defTerms = definitionNames.map(function (d) {
                return '{"term":{"definitionName":"' + d + '"}}';
            });
            mustArray.push('{"bool":{"should":[' + defTerms.join(',') + '],"minimum_should_match":1}}');
        }
        return (
            '{"query":{"bool":{"must":[' + mustArray.join(',') + ']}},' +
            '"size":' + size + ',"sort":[{"saleRank":{"order":"desc"}},{"rating":{"order":"desc"}}],' +
            '"_source":{"includes":["brand","catalog","name","listPrice","salePrice","clubPrice","itemId","variants.variantId","variants.numberOfDesigns","isBuyable","definitionName","rating","saleRank","yearCreated","videoParts","runTime"]}}'
        );
    };

    this.buildProductByIdsRequest = function (searchTerm) {
        return '{"track_total_hits": true, "query":{"ids":{"values":' + searchTerm + '}}}';
    };
});
